import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchPastAppointment } from "../../../../shared/hooks/useFetchAppointment";
import API_URLS from "../../Utils/axr";
import { checkIsPastDate } from "../../../../shared/utils/dateUtils";
import { errorConditionGTM } from "../../Utils/googleTags";
import store, { RootState } from "../store";
import { getServiceAddressFromUser, shouldSkipFailedOutApiFetch, shouldStopApiRetry, logApiRetryCapDwLog } from "../../Utils/utils";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import { hasCompletedOrCanceledBuriedDrop } from "../../Utils/buriedDropStatus";

type pastAppointmentInitialStateType = {
  pastAppointment: any;
  loading: boolean;
  error: any;
  fetched: boolean;
  retryCount: number;
};
const initialState: pastAppointmentInitialStateType = {
  pastAppointment: null,
  loading: false,
  error: null,
  fetched: false,
  retryCount: 0,
};

// export const getPastAppointment = createAsyncThunk(
//   "past/appointment",
//   async (billingAccountNumber: string) => {
//     try {
//       const response = await fetchPastAppointment({
//         [API_URLS?.fetchPastAppointments]: billingAccountNumber,
//       });
//       if (
//         response?.data?.length &&
//         response?.data[0] &&
//         response?.data[0]?.orderDetails?.orderHistoryDetails
//       ) {
//         return response?.data[0]?.orderDetails?.orderHistoryDetails;
//       }
//       return response?.data;
//     } catch (error) {
//       throw error;
//     }
//   }
// );

export const getPastAppointment = createAsyncThunk(
  "past/appointment",
  async (user: any) => {
    const { billingAccountNumber } = user;
    const serviceAddLocal = getServiceAddressFromUser(user);
    const reduxStore = store.getState();
    const headers = reduxStore?.brightspeedToken?.headers;
    let url=API_URLS['fetchPastAppointments'];
    try {
      const response = await fetchPastAppointment(
        {
          "": `${url}?ban=${billingAccountNumber}&addressId=${serviceAddLocal?.addressId}`,
        },
        headers
      );

      if (
        response &&
        response?.data &&
        response?.data?.userAppointments.length &&
        response?.data?.userAppointments[0]?.order
      ) {
        return response?.data?.userAppointments[0]?.order?.reduce(
                (acc: any[], anOrder: any) => {
                  if (acc.length === 0) {
                    acc.push({ burriedDropInfo: [] });
                    acc.push({ techInstallationInfo: [] });
                  }
                  if (anOrder?.installType?.toUpperCase() === "S") {
                    return acc;
                  }
                  const isApptCompletedOrCanceled =
                    checkIsPastDate(anOrder?.apptDetails?.appointmentDate) &&
                   ( anOrder?.orderStatus?.toLowerCase() === "canceled" ||
                    anOrder?.orderStatus?.toLowerCase() === "completed" ||
                    anOrder?.orderStatus?.toLowerCase() === "cannot complete" ||
                    anOrder?.orderStatus?.toLowerCase()?.includes("cancels"));

                  const isBuriedDropCompletedOrCanceled =
                    hasCompletedOrCanceledBuriedDrop(anOrder?.burriedDropInfo);
                 
                  if (isApptCompletedOrCanceled) {
                    acc[1].techInstallationInfo.push(anOrder);
                  } 
                  if (isBuriedDropCompletedOrCanceled) {
                    acc[0].burriedDropInfo.push(anOrder.burriedDropInfo);
                  }
                  return acc;
                },
                []
        );
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const state = (getState() as RootState).pastAppointment;
      if (state.loading) {
        return false;
      }
      if (shouldSkipFailedOutApiFetch(!!state.pastAppointment, state.fetched)) {
        return false;
      }
      return true;
    },
  }
);

const pastAppointmentSlice = createSlice({
  name: "past/appointment",
  initialState,
  reducers: {
    clearPastAppointmentSlice: (state) => {
      return initialState;
    },
    pastAppointmentSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPastAppointment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPastAppointment.fulfilled, (state, action) => {
      state.pastAppointment = action.payload;
      state.loading = false;
      state.error = null;
      state.retryCount = 0;
      state.fetched = true;
    });
    builder.addCase(getPastAppointment.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "past appointment",
        action.error?.message,
        action?.type
      );
      state.pastAppointment = null;
      state.loading = false;
      state.error = action.error;
      state.retryCount += 1;
      if (shouldStopApiRetry(state.retryCount)) {
        state.fetched = true;
        logApiRetryCapDwLog(
          EC_DW_LOGGING_STEPS.past_appointment_API_retry_cap,
          action.error?.message
        );
      }
    });
  },
});

export const {
  clearPastAppointmentSlice,
  pastAppointmentSliceSetInitialState,
} = pastAppointmentSlice.actions;
export default pastAppointmentSlice.reducer;
